import { ColDef } from "ag-grid-community";
import { Info, ScopeCellRenderer } from "./GridFrameworks";

export const columnDef: ColDef[] = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 65,
        minWidth: 65,
        pinned: "left",
    },
    {
        headerName: "Role Identifier",
        field: "Id",
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: "Role Name",
        field: "Name",
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Scope",
        field: "IsDefault",
        cellRenderer: ScopeCellRenderer,
        width: 140,
    },
    {
        headerName: "Description",
        field: "Description",
        flex: 2,
        minWidth: 300,
    },
];
